import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { membershipApi, type Membership } from '../../api/memberships';

export function MemberDetailPage() {
  const { id = '' } = useParams();
  const [membership, setMembership] = useState<Membership | null>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    void membershipApi
      .get(id)
      .then(setMembership)
      .catch((err) => setError(err instanceof Error ? err.message : 'Failed to load member'))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <p className="p-6 text-slate-600">Loading member…</p>;
  if (error || !membership) return <p className="p-6 text-red-600">{error || 'Member not found'}</p>;

  return (
    <div className="mx-auto max-w-3xl p-6">
      <Link to="/members" className="text-sm text-slate-600 hover:underline">← Member directory</Link>
      <h1 className="mt-4 text-2xl font-semibold">Member Details</h1>
      <div className="mt-6 space-y-4 rounded-xl border bg-white p-6 text-sm">
        <div><span className="text-slate-500">Identity</span><p className="font-medium">{membership.identity_id}</p></div>
        <div><span className="text-slate-500">Scope</span><p className="capitalize">{membership.scope.type}</p></div>
        <div><span className="text-slate-500">Status</span><p className="capitalize">{membership.status}</p></div>
        <div><span className="text-slate-500">Primary</span><p>{membership.is_primary ? 'Yes' : 'No'}</p></div>
        <div><span className="text-slate-500">Created</span><p>{new Date(membership.created_at).toLocaleString()}</p></div>
      </div>
      <div className="mt-4 flex gap-3 text-sm">
        <Link to="/members/manage" className="text-slate-700 hover:underline">Manage lifecycle</Link>
        <Link to={`/users/${membership.identity_id}`} className="text-slate-700 hover:underline">User profile</Link>
      </div>
    </div>
  );
}
